import { useTranslation } from "react-i18next";
import { FileText, Calendar, Hash, Percent, Sigma } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// بطاقة تفاصيل الفاتورة — رقم الفاتورة، التاريخ، الصافي، الضريبة، الإجمالي، الغرض.
export const MyBillSignDetails = ({ bill, cashbox, branch }) => {
  const { t } = useTranslation();
  const cur = (bill.currency || branch?.currency || cashbox?.currency || "").toUpperCase();
  const tax = Number(bill.tax || 0);
  const net = Number(bill.total || 0) - tax;
  const Row = ({ Icon, label, value, strong = false, tone = "slate" }) => (
    <div className="flex items-center justify-between gap-3 border-b border-slate-100 py-2 last:border-b-0">
      <span className="flex items-center gap-2 text-xs font-bold text-slate-600">
        <Icon className={`h-3.5 w-3.5 text-${tone}-500`} /> {label}
      </span>
      <span className={`font-black ${strong ? "text-sm text-emerald-700" : "text-xs text-slate-900"}`} dir="ltr">
        {value}
      </span>
    </div>
  );
  return (
    <div className="rounded-2xl border-2 border-slate-200 bg-white p-4" data-testid="my-bill-details">
      <p className="mb-2 flex items-center gap-2 text-sm font-black text-slate-800">
        <FileText className="h-4 w-4" /> {t("acct.bills.mysign.billDetails")}
      </p>
      <Row Icon={Hash}     label={t("acct.bills.mysign.invoiceNo")} value={bill.supplier_invoice_no || "—"} />
      <Row Icon={Calendar} label={t("acct.bills.mysign.date")}      value={bill.date || "—"} tone="blue" />
      <Row Icon={FileText} label={t("acct.bills.mysign.netAmount")} value={`${fmt(net)} ${cur}`} />
      {tax > 0 ? <Row Icon={Percent} label={t("acct.bills.mysign.tax")} value={`${fmt(tax)} ${cur}`} tone="amber" /> : null}
      <Row Icon={Sigma}    label={t("acct.bills.mysign.totalAmount")} value={`${fmt(bill.total)} ${cur}`} strong tone="emerald" />
      {bill.description ? (
        <div className="mt-3 rounded-xl bg-slate-50 p-3 text-xs text-slate-700">
          <span className="font-black text-slate-900">{t("acct.bills.mysign.purpose")}: </span>
          {bill.description}
        </div>
      ) : null}
    </div>
  );
};
